import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavbarV2 from './navbar-v2';
import FooterV2 from './footer-v2';

export default function TermsOfService() {
  // Sayfa yüklendiğinde en üste scroll yap
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white">
      <NavbarV2 />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-50 to-indigo-50 py-16 pt-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Kullanım Koşulları</h1>
            <p className="text-lg text-gray-600 mb-6">
              Uygulamamızı kullanırken uymanız gereken kurallar ve koşullar
            </p>
            <div className="flex items-center justify-center text-sm text-gray-500">
              <Link to="/" className="hover:text-red-500">Ana Sayfa</Link>
              <span className="mx-2">/</span>
              <span className="text-red-500">Kullanım Koşulları</span>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white border rounded-xl p-8 shadow-sm">
              {/* Last Updated */}
              <div className="mb-8 p-4 bg-gray-50 rounded-lg">
                <p className="text-sm text-gray-600">
                  <strong>Son güncelleme:</strong> 2 Eylül 2025
                </p>
              </div>

              {/* Sections */}
              <div className="space-y-8">
                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Tanımlar</h2>
                  <div className="text-gray-700">
                    <p>
                      "Uygulama" Hatim Takip mobil ve web arayüzlerini; "Kullanıcı" uygulamaya kayıt olup 
                      hizmetlerden yararlanan kişiyi ifade eder.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Hizmet Kapsamı</h2>
                  <div className="text-gray-700">
                    <p>
                      Uygulama; Kur'an ve Risale okuma/hatim takip gruplarının oluşturulması, 
                      yönetimi ve ilerleme takibini sağlar.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Kayıt ve Hesap Güvenliği</h2>
                  <div className="text-gray-700">
                    <p>
                      Kayıt olurken sağlanan bilgilerin doğruluğundan kullanıcı sorumludur. 
                      Hesap bilgilerinizi üçüncü kişilerle paylaşmayın.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Kullanıcı Yükümlülükleri</h2>
                  <div className="text-gray-700">
                    <ul className="list-disc ml-6 space-y-2">
                      <li>Yasalara, genel ahlak ve nezaket kurallarına aykırı içerik paylaşmamak</li>
                      <li>Başka kullanıcıların haklarını ihlal etmemek</li>
                      <li>Hizmeti kötüye kullanacak otomasyon / bot faaliyetlerinde bulunmamak</li>
                    </ul>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Yasaklı Kullanımlar</h2>
                  <div className="text-gray-700">
                    <p>
                      Tersine mühendislik, saldırı testleri, yetkisiz veri toplama ve spam yasaktır.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Bağış Sistemi</h2>
                  <div className="text-gray-700">
                    <p>
                      Uygulama zorunlu ücret veya abonelik içermez. Gönüllü bağış ödemeleri İyzico altyapısı 
                      üzerinden işlenir; kart verileri uygulama sunucularında tutulmaz.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Fikri Mülkiyet</h2>
                  <div className="text-gray-700">
                    <p>
                      Logo, marka ve arayüz tasarımları ilgili hak sahiplerine aittir. İzinsiz kopyalanamaz.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Sorumluluk Reddi</h2>
                  <div className="text-gray-700">
                    <p>
                      Hizmet "olduğu gibi" sunulur. Kesinti, veri kaybı veya üçüncü taraf servis 
                      kesintilerinden doğan zararlardan sorumluluk kabul edilmez.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Veri Koruma</h2>
                  <div className="text-gray-700">
                    <p>
                      Kişisel verilerin işlenmesi{' '}
                      <Link to="/privacy-policy" className="text-red-500 hover:underline font-medium">
                        Gizlilik Politikası
                      </Link>
                      {' '}kapsamında yürütülür.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Hesap Sonlandırma</h2>
                  <div className="text-gray-700">
                    <p>
                      Kullanıcı e-posta ile hesap silme talebi gönderebilir. Uygulama koşulları ihlal edilirse 
                      hesap uyarı veya kapatma yoluyla sonlandırılabilir.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Değişiklikler</h2>
                  <div className="text-gray-700">
                    <p>
                      Koşullar güncellenebilir. Güncellemeler sayfa üzerinde yayınlandığı anda yürürlüğe girer.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. İletişim</h2>
                  <div className="text-gray-700">
                    <p>
                      Sorularınız için:{' '}
                      <a 
                        href="mailto:gudersamet@gmail.com" 
                        className="text-red-500 hover:underline font-medium"
                      >
                        gudersamet@gmail.com
                      </a>
                    </p>
                  </div>
                </section>
              </div>

              {/* Related Pages */}
              <div className="mt-12 pt-8 border-t border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">İlgili Sayfalar</h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <Link 
                    to="/privacy-policy" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Gizlilik Politikası</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Kişisel verilerinizin korunması ve gizliliği
                    </p>
                  </Link>
                  <Link 
                    to="/account-deletion" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Hesap & Veri Silme</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Hesap silme sürecinin detayları
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterV2 />
    </div>
  );
}
